export default __webpack_public_path__ + "static/media/v45_32.c7925662.png";